<template>
  <div class="wrapper">
    <div class="body">
        <div :class="{'text': true, 'text-ellipsis-1-no-wrap': !show_more}"
          @click="showMore"
          v-html="formatCommonText(notification.contexts.item_comment.text)"
          ></div>
    </div>
    <div class="actions">
      <div v-if="commentBodyIsMoreThan3Lines && show_more" @click="showMore"><i class="icon-angle-top"></i> Show less</div>
      <div v-else-if="commentBodyIsMoreThan3Lines" @click="showMore"><i class="icon-angle-bottom"></i> Show more</div>
      <NuxtLink :to="notification.contexts.item_comment.link + '?lnk=' + notification.contexts.item_comment.id"><i class="icon-external"></i> Go to comment</NuxtLink>
      <div v-if="allowReply" @click="reply"><i class="icon-reply"></i> {{ $t('comments_view_reply') }}</div>
    </div>

    <CommentFormFlow
      v-if="useAuth().isAuth() && reply_form"
      :content="notification.contexts.item_comment.content_id"
      :type="notification.contexts.item_comment.s_type"
      :reply-id="notification.contexts.item_comment.id"
      :reply-to-user-name="notification.contexts?.item_user?.name"
      :parent-id="notification.contexts.item_comment.parent_id ? notification.contexts.item_comment.parent_id : notification.contexts.item_comment.id"
      @closed="reply_form=false"
      @created="handleNewReply($event)"
      />  

  </div>
</template>

<script setup lang="ts">

import { NotificationType } from '@/types/notification'
import { formatCommonText } from '@/types/other';
const { t } = useI18n();
const props = defineProps<{ notification: Notification }>()

const reply_form = ref(false);
const show_more = ref(false);

const reply = () => {
  reply_form.value = !reply_form.value;
}

const handleNewReply = (newReply) => {
  // useToast().success(t('comments_view_message_post_success'));
}

const commentBodyIsMoreThan3Lines = computed(() => {
  return props.notification.contexts.item_comment.text.split('\n').length > 1;
})

const showMore = () => {
  show_more.value = !show_more.value;
}

const allowReply = computed(() => {
  return useAuth().isAuth() && 
  (
    props.notification.type !== NotificationType.LikeMyComment
    &&
    props.notification.type !== NotificationType.ModerateCommentMyComplain
    &&
    props.notification.type !== NotificationType.ComplaintMyComment
  )
})

</script>

<style scoped>

.wrapper{
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
}
.body{
  width: 100%;
}
.actions{
  width: 100%;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
}
.actions > *{
  cursor: pointer;
    display: flex;
    color: var(--gd-button-light-small-color);
    font-size: 0.75rem;
    text-transform: capitalize;
    position: relative;
    align-items: center;
    gap: 5px;
}
.text{  
  white-space: pre-wrap;
}


</style> 